import { render, staticRenderFns } from "./LoanTypeSelect.vue?vue&type=template&id=51b71322&"
import script from "./LoanTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./LoanTypeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports